/**
 * @description Hook utilizado para manipular as operações de Exame de Tortura e Maus-tratos
 * @author Diego Sabino Amorim de Araújo
 * @file useExameMausTratosService.js
 * @license Copyright (c) 2024 SIGEP DIGETI ITEP/RN
 */

import { useFetch } from './useFetch'

export const useExameMausTratosService = () => {
  const fetch = useFetch()

  const listarExameMausTratosDetalhadoAsync = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)

      const result = await fetch.get(`exameMausTratos/detalhado/${id}`)
      return result.data.exameMausTratos
    } catch (err) {
      throw err
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const confirmarDadosExameMausTratos = async (id, dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      await fetch.putOpen(`exameMausTratos/preencher/${id}`, dados)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const editarExameMausTratos = async (id, dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      await fetch.putOpen(`exameMausTratos/editar/${id}`, dados)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  return { listarExameMausTratosDetalhadoAsync, confirmarDadosExameMausTratos, editarExameMausTratos }
}
